import { motion } from 'framer-motion';
import { ChevronDown, Star } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_premium-brew-36/artifacts/glj0sgxs_WhatsApp%20Image%202026-02-18%20at%2018.37.17.jpeg";

const Hero = () => {
  const scrollToAbout = () => {
    const element = document.querySelector('#about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1920&q=80"
          alt="Coffee shop ambiance"
          className="w-full h-full object-cover"
          data-testid="hero-bg-image"
        />
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a2e23]/60 via-[#1a2e23]/40 to-[#1a2e23]" />
      </div>

      {/* Content */}
      <div className="relative z-10 container-custom text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: 'easeOut' }}
          className="max-w-4xl mx-auto"
        >
          {/* Accent text */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="font-accent text-[#d4a84b] text-2xl md:text-3xl mb-4"
            data-testid="hero-accent-text"
          >
            Her yudumda mükemmellik
          </motion.p>

          {/* Main title */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="font-['Playfair_Display'] text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold text-[#f5f0e1] mb-6 leading-tight"
            data-testid="hero-title"
          >
            Polje Coffee Co
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
            className="text-[#b8c4b8] text-lg md:text-xl max-w-2xl mx-auto mb-8"
            data-testid="hero-subtitle"
          >
            Ankara'nın kalbinde, özenle seçilmiş çekirdekler ve tutkuyla hazırlanan kahveler
          </motion.p>

          {/* Rating badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.9, duration: 0.6 }}
            className="inline-flex items-center gap-2 glass px-6 py-3 rounded-full mb-12"
            data-testid="hero-rating"
          >
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#d4a84b] text-[#d4a84b]" />
              ))}
            </div>
            <span className="text-[#f5f0e1] font-semibold">5.0</span>
            <span className="text-[#b8c4b8]">/ 15 değerlendirme</span>
          </motion.div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.8 }}
          onClick={scrollToAbout}
          className="absolute bottom-12 left-1/2 -translate-x-1/2 text-[#b8c4b8] hover:text-[#d4a84b] transition-colors cursor-pointer"
          data-testid="scroll-indicator"
          aria-label="Scroll down"
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
          >
            <ChevronDown className="w-8 h-8" />
          </motion.div>
        </motion.button>
      </div>
    </section>
  );
};

export default Hero;
